export { default } from './BannerWithTradeRouteWidget';
